// extracted by mini-css-extract-plugin
module.exports = {"video":"Video_video___6UHx","isPlaying":"Video_isPlaying__PcCi3","icon":"Video_icon__u6tmY","loading":"Video_loading__vScsu","scale":"Video_scale__W2pci"};